import { prependRoot } from "../../util/prependRoot.js";
import { getApiRoot } from "../../store/configureStore.js";
import axios from "axios";

const ToelatingenApi = {
	get(tochtId) {
		const url = prependRoot("toelatingen/" + tochtId, getApiRoot());
		return axios.get(url, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getForGemeenteByTochtId(tochtId) {
		const url = prependRoot("toelatingen/" + tochtId + '/gemeente', getApiRoot());
		return axios.get(url, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	save(models, documents) {
		const serviceUrl = prependRoot('toelatingen/', getApiRoot());
		return axios.put(serviceUrl, {
			item: models,
			documenten: documents
		},
			{
				headers: {
					'accept': 'application/json'
				}
			});
	},
	savePerGemeente(model, documents) {
		const serviceUrl = prependRoot('toelatingen/savePerGemeente', getApiRoot());
		return axios.put(serviceUrl, {
            item: model,
			documenten: documents
		},
			{
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default ToelatingenApi;